import React from "react";
import LIcon from "@components/LIcon";
import { router } from "expo-router";
import LPressable from "@components/LPressable";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";

const SearchButton = () => {
  const isOnExplore = useNavigationStore(
    (state) => state.tab === "explore",
  );

  return (
    <LPressable
      sentryEventName="search_button"
      onPress={() => router.navigate(`/(app)/(tabs)/explore`)}
      style={{
        height: 40,
        width: 40,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LIcon
        colors={{ color: isOnExplore ? "#E6765A" : "white" }}
        name="search"
        size={25}
        fadeEnabled
      />
    </LPressable>
  );
};

export default SearchButton;
